var map = {
	"./add.svg": "3592",
	"./ele-sign.svg": "784b",
	"./email.svg": "eb49",
	"./icons_Marketing_resources.svg": "0e53",
	"./icons_coins.svg": "93a2",
	"./icons_flex.svg": "fcdc",
	"./icons_increase.svg": "db9a",
	"./icons_online_card.svg": "edd6",
	"./icons_user_support.svg": "a42c",
	"./search-icon.svg": "1ae5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";